import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "TitleChip"
})
export default class TitleChip extends Vue {
  @Prop() private title!: string;
}
